// Blade loads the existing jQuery before Vite so inline page scripts and
// bundled vendor plugins share exactly one instance, with no version change.
module.exports = window.jQuery;
